import { snakeCase } from 'lodash-es';

/**
 *
 * @param formData
 * @returns an object with the keys in snake_case and the values as strings
 * @description We use this to format the form data before sending it to Segment as event properties.
 */
export function transformFormDataToEventProperties(
  formData: Record<string, string | { value: string; label: string }>
) {
  return Object.fromEntries(
    Object.entries(formData).map(([key, value]) => {
      return [snakeCase(key), typeof value === 'object' ? value.value : value];
    })
  );
}
